export default "__VITE_ASSET__07851657__"